import {
  addDays,
  addMonths,
  format,
  isEqual,
  isFuture,
  subDays,
  subMonths,
} from 'date-fns';
import { ar } from 'date-fns/locale';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import ka from 'date-fns/locale/ka';

type TSetDateFun = React.Dispatch<React.SetStateAction<Date>>;

export const addMonthHandler = (date: Date, setDate: TSetDateFun) => {
  setDate(addMonths(date, 1));
};
export const subMonthHandler = (date: Date, setDate: TSetDateFun) => {
  setDate(subMonths(date, 1));
};

export const addDayHandler = (date: Date, setDate: TSetDateFun) => {
  setDate(addDays(date, 1));
};
export const subDayHandler = (date: Date, setDate: TSetDateFun) => {
  setDate(subDays(date, 1));
};

export const getDateFormat = (
  date: Date,
  language: string,
  formatDate: string
) => {
  return format(date, formatDate, {
    locale:
      language === 'ar'
        ? ar
        : language === 'es'
        ? es
        : language === 'ka'
        ? ka
        : language === 'fr'
        ? fr
        : en,
  });
};

export const datePickerChangeHandler = (date: Date, setDate: TSetDateFun) => {
  setDate(date);
};

export const getDayNameFormat = (
  date: Date,
  dayNumber: number,
  language: string
) => {
  return format(addDays(date, dayNumber), 'EEEE', {
    locale: language === 'ar' ? ar : language === 'es' ? es : en,
  });
};

export const getDayNumberFormat = (date: Date, dayNumber: number) => {
  return format(addDays(date, dayNumber), 'd');
};

export const isEqualCurrenSelectedtDay = (dateLeft: Date, dateRight: Date) => {
  return isEqual(
    new Date(format(dateLeft, 'MM/dd/yyyy')),
    new Date(format(dateRight, 'MM/dd/yyyy'))
  );
};

export const isExceedCurrentDay = (date: Date) => {
  return isFuture(date);
};
